import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const AddressPostalIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.56759 8.80898C1.33224 7.27745 1.21457 6.51173 1.50411 5.8329C1.79364 5.15406 2.43602 4.6896 3.72076 3.76069L4.68065 3.06665C6.27885 1.91109 7.07793 1.33331 8 1.33331C8.92206 1.33331 9.72113 1.91109 11.3193 3.06665L12.2793 3.76069C13.564 4.6896 14.2063 5.15406 14.4959 5.8329C14.7854 6.51173 14.6677 7.27745 14.4324 8.80898L14.2317 10.1149C13.8981 12.2859 13.7313 13.3714 12.9527 14.019C12.1741 14.6666 11.0358 14.6666 8.75919 14.6666H7.2408C4.96422 14.6666 3.82594 14.6666 3.04733 14.019C2.26872 13.3714 2.10191 12.2859 1.76828 10.1149L1.56759 8.80898Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9.16666 7.66667C9.16666 8.311 8.64433 8.83333 7.99999 8.83333C7.35566 8.83333 6.83333 8.311 6.83333 7.66667C6.83333 7.02233 7.35566 6.5 7.99999 6.5C8.64433 6.5 9.16666 7.02233 9.16666 7.66667Z"
      stroke={color}
    />
    <path
      d="M8 5C9.62353 5 11 6.41154 11 8.12403C11 9.86377 9.6011 11.0846 8.309 11.9148C8.21483 11.9707 8.10833 12 8 12C7.89167 12 7.78517 11.9707 7.691 11.9148C6.4013 11.0766 5 9.86979 5 8.12403C5 6.41154 6.37648 5 8 5Z"
      stroke={color}
    />
  </svg>
);
export const AddressVisitIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.56759 8.80898C1.33224 7.27745 1.21457 6.51173 1.50411 5.8329C1.79364 5.15406 2.43602 4.6896 3.72076 3.76069L4.68065 3.06665C6.27885 1.91109 7.07793 1.33331 8 1.33331C8.92206 1.33331 9.72113 1.91109 11.3193 3.06665L12.2793 3.76069C13.564 4.6896 14.2063 5.15406 14.4959 5.8329C14.7854 6.51173 14.6677 7.27745 14.4324 8.80898L14.2317 10.1149C13.8981 12.2859 13.7313 13.3714 12.9527 14.019C12.1741 14.6666 11.0358 14.6666 8.75919 14.6666H7.2408C4.96422 14.6666 3.82594 14.6666 3.04733 14.019C2.26872 13.3714 2.10191 12.2859 1.76828 10.1149L1.56759 8.80898Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M10.002 6C10.002 4.89543 9.10655 4 8.00195 4C6.89735 4 6.00195 4.89543 6.00195 6C6.00195 7.1046 6.89735 8 8.00195 8C9.10655 8 10.002 7.1046 10.002 6Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66864 11.3333C4.66864 9.4924 6.16103 8 8.00197 8C9.05151 8 9.98771 8.48507 10.5987 9.2432"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AddressLegalIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.56759 8.80898C1.33224 7.27745 1.21457 6.51173 1.50411 5.8329C1.79364 5.15406 2.43602 4.6896 3.72076 3.76069L4.68065 3.06665C6.27885 1.91109 7.07793 1.33331 8 1.33331C8.92206 1.33331 9.72113 1.91109 11.3193 3.06665L12.2793 3.76069C13.564 4.6896 14.2063 5.15406 14.4959 5.8329C14.7854 6.51173 14.6677 7.27745 14.4324 8.80898L14.2317 10.1149C13.8981 12.2859 13.7313 13.3714 12.9527 14.019C12.1741 14.6666 11.0358 14.6666 8.75919 14.6666H7.2408C4.96422 14.6666 3.82594 14.6666 3.04733 14.019C2.26872 13.3714 2.10191 12.2859 1.76828 10.1149L1.56759 8.80898Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7.2222 8.11113C7.92553 8.8144 8.85187 9.52913 8.85187 9.52913L10.1217 8.25927C10.1217 8.25927 9.407 7.33293 8.70373 6.62963C8.0004 5.92633 7.07407 5.21164 7.07407 5.21164L5.80423 6.48148C5.80423 6.48148 6.51893 7.40781 7.2222 8.11113ZM7.2222 8.11113L5 10.3333M10.3333 8.0476L8.6402 9.74073M7.28573 5L5.59259 6.69312"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5 13H11" stroke={color} strokeLinecap="round" />
  </svg>
);
